import { createContext } from "react";
import { AwsFile } from "../../models";
import { Any } from "../../test-helpers/Any";

export type IAwsFilesContext = {
    awsFiles?: AwsFile[];
    clearAwsFiles: VoidFunction;
};

export const defaultAwsFilesContext: IAwsFilesContext = {
    clearAwsFiles: Any.voidFn,
};

export const AwsFilesContext = createContext(defaultAwsFilesContext);
AwsFilesContext.displayName = "AwsFiles";
